// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__7a0Jh","mainColor":"styles_mainColor__9LfW5","dark":"styles_dark__UvdrD","light":"styles_light__3tono","largeIcon":"styles_largeIcon__qPsQc"};